import { axiosPrivate } from 'shared/api';
import { BaseService } from 'shared/services/BaseService';
import { IWarehouse } from '../types';

class WarehouseService extends BaseService<IWarehouse> {
  constructor() {
    super('warehouses');
  }
  canDelete = true;
  canBulkDelete = true;

  public async get(id: number | string) {
    if (typeof id === 'number') return super.get(id);
    const [warehouse] = await this.getAllBaseInformation({ code: id, code__exact: 'true' });
    if (!warehouse) throw new Error(`Warehouse not found: ${id}`);
    return super.get(warehouse.id);
  }

  assignProduct = async (
    warehouseId: number,
    product: number,
    restock_threshold?: number,
    understock_threshold?: number,
    overstock_threshold?: number,
    status?: number,
    notes?: string
  ) => {
    const res = await axiosPrivate.patch(`${this.modulePrefix}/${warehouseId}/assign_product/`, {
      product,
      restock_threshold,
      understock_threshold,
      overstock_threshold,
      status,
      notes
    });
    return res.data;
  };

  removeProduct = async (warehouseId: number, product: number) => {
    const res = await axiosPrivate.patch(`${this.modulePrefix}/${warehouseId}/remove_product/`, {
      product
    });
    return res.data;
  };
}

export const warehouseService = new WarehouseService();
